import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { submit } from 'redux-form'
import { IStore } from '../../../reducers'
import { getRoomModalIsSaving } from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { FormNames } from '../../Form/CreateRoom'
import closeModal from '../../../actions/Modals/closeModal'
import openModal from '../../../actions/Modals/openModal'
import { IRoomModalDispatch, IRoomModalProps } from './RoomModal'

const mapStateToProps = () => {
  return (state: IStore): IRoomModalProps => ({
    isSaving: getRoomModalIsSaving(state),
    type: 'create',
  })
}

const bindDispatchToProps = (dispatch: Dispatch): IRoomModalDispatch => ({
  modalClose(id) {
    dispatch(closeModal(id))
  },
  modalOpen(id, element) {
    dispatch(openModal(id, element))
  },
  submitForm() {
    dispatch(submit(FormNames.Create))
  },
})

export default connect<IRoomModalProps, IRoomModalDispatch, any>(
  mapStateToProps(),
  bindDispatchToProps,
)
